<template>
  <div>
    <h1 class="page-header">{{ $t('vehicleZoneProfile.pageTitle') }}</h1>
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="form-group m-b-15">
              <label>{{ $t('vehicleZoneProfile.zoneNameKH') }}</label>
              <input
                v-model="model.zone_name_kh"
                type="text"
                class="form-control kh-font"
                :class="{ 'is-invalid': errors.has('zone_name_kh') }"
                :placeholder="$t('vehicleZoneProfile.enterZoneNameKH')"
              />
              <div class="invalid-feedback" v-if="errors.has('zone_name_kh')">
                {{ errors.first('zone_name_kh') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="required">{{
                $t('vehicleZoneProfile.zoneNameEN')
              }}</label>
              <input
                v-model="model.zone_name_en"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': errors.has('zone_name_en') }"
                :placeholder="$t('vehicleZoneProfile.enterZoneNameEN')"
              />
              <div class="invalid-feedback" v-if="errors.has('zone_name_en')">
                {{ errors.first('zone_name_en') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="required"
                >{{ $t('vehicleZoneProfile.lattitude') }}
              </label>
              <input
                v-model.number="model.lattitude"
                type="number"
                step="any"
                class="form-control"
                :class="{ 'is-invalid': errors.has('lattitude') }"
                :placeholder="$t('vehicleZoneProfile.enterLattitude')"
              />
              <div class="invalid-feedback" v-if="errors.has('lattitude')">
                {{ errors.first('lattitude') }}
              </div>
            </div>
            <div class="form-group m-b-15">
              <label class="required">{{
                $t('vehicleZoneProfile.longitude')
              }}</label>
              <input
                v-model.number="model.longitude"
                type="number"
                step="any"
                class="form-control"
                :class="{ 'is-invalid': errors.has('longitude') }"
                :placeholder="$t('vehicleZoneProfile.enterLongitude')"
              />
              <div class="invalid-feedback" v-if="errors.has('longitude')">
                {{ errors.first('longitude') }}
              </div>
            </div>
            <div class="text-right">
              <ts-button v-if="updating" class="mr-2" @click.prevent="cancel">
                {{ $t('cancel') }}
              </ts-button>
              <ts-button
                v-if="updating"
                class="btn-primary"
                :waiting="waiting"
                @click.prevent="update"
              >
                {{ $t('update') }}
              </ts-button>
              <ts-button
                v-if="!updating"
                :waiting="waiting"
                class="btn-primary"
                @click.prevent="store"
                >{{ $t('save') }}</ts-button
              >
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-9 col-sm-12">
        <data-table :fetch="fetch" @fetched="fetch = false"></data-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DataTable from './table'
import { Errors } from 'form-backend-validation'

export default {
  name: 'study-time-form',
  components: {
    DataTable
  },
  data() {
    return {
      model: {
        zone_id: '',
        zone_name_kh: '',
        zone_name_en: '',
        lattitude: '',
        longitude: ''
      },
      errors: new Errors(),
      waiting: false,
      fetch: false,
      updating: false
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('vehicleZoneProfile', ['edit_data'])
  },
  methods: {
    store() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('vehicleZoneProfile/store', this.model)
        .then(response => {
          this.clearInput()
          this.$toasted.success(response.message)
          this.waiting = false
          this.fetch = true
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },
    update() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('vehicleZoneProfile/update', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.waiting = false
          this.fetch = true
          this.cancel()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },

    cancel() {
      this.updating = false
      this.$store.commit('vehicleZoneProfile/SET_EDIT_DATA', {})
      this.$router.push({ name: 'vehicle-zone-profile' })
      this.clearInput()
    },
    clickBackURL() {
      this.$store.commit('vehicleZoneProfile/SET_EDIT_DATA', {})
      this.clearInput()
      this.fetch = true
      this.updating = false
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.errors = new Errors()
        this.model = _.clone(this.edit_data)
        this.updating = true
      }
    },
    clearInput() {
      this.model = {
        zone_id: '',
        zone_name_kh: '',
        zone_name_en: '',
        lattitude: '',
        longitude: ''
      }
    }
  },
  watch: {
    edit_data: {
      handler() {
        this.setEditData()
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('vehicleZoneProfile/RESET_STATE')
      this.clickBackURL()
    }
    next()
  }
}
</script>
